import { Application } from "stimulus"

let Stimulus

if (!Stimulus) {
  Stimulus = Application.start()
}

export default Stimulus
